export enum EdemaPittingEnum {
  No = 1,
  YesOne = 2,
  YesTwo = 3,
  YesThree = 4,
  YesFour = 5
}

export const EdemaPittingOptions = [
{ id: 1, label: 'No' },
{ id: 2, label: 'Yes: +1' },
{ id: 3, label: 'Yes: +2' },
{ id: 4, label: 'Yes: +3' },
{ id: 5, label: 'Yes: +4' }
];
